module.exports = __webpack_public_path__ + "static/media/Credits-28.2dcb0d35.pdf";